import React from "react"
import { useTranslation } from "react-i18next"

import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { SocialShare } from "~/components/Social/SocialShare/SocialShare"

import styles from "./index.module.css"

export const Share: React.FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation()

  return (
    <div className={className}>
      <Heading className={styles.Title} like="h4">
        <Raw html={t("ContentEditable.Share")} />
      </Heading>

      <SocialShare />
    </div>
  )
}
